export const VARIANTS = {
  BASE: 'base',
  PROGRESS: 'progress',
  SEGMENTED: 'segmented'
};
